import ConfirmationPage from '../../shared/booking/ConfirmationPage';
import TransferSummary from './TransferSummary';
import TransferRide from './TransferRide';

export default function TransferConfirmation() {
  return (
    <ConfirmationPage
      module="transfers"
      Summary={TransferSummary}
      refLabel="Cab booking ID"
      Extra={TransferRide}
      nextSteps={[
        'Driver name and number are shared before pickup — usually within 12 hours for trips in India.',
        'At the airport, look for the driver holding your name board at the arrivals gate.',
        'Track your driver and see the ride status from My Trips.',
        'Cancel online from My Trips; the refund depends on how long before pickup you cancel.',
      ]}
    />
  );
}
